import { TRPCClientError } from "@trpc/client";
import { APPLICATION_FORMS_REQUIRED_ERROR_CODE } from "@api/shared-runtime/application-forms";

/**
 * Whether `jobPost.submitApplication` refused the application because a
 * screening form is unsubmitted, e.g. the organization added one after the
 * dialog opened. The API forwards BAD_REQUEST causes on `shape.data.cause`.
 */
export function isApplicationFormsRequiredError(error: unknown): boolean {
  if (!(error instanceof TRPCClientError)) {
    return false;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cause = (error as any)?.shape?.data?.cause as
    | { code?: string }
    | undefined;
  return cause?.code === APPLICATION_FORMS_REQUIRED_ERROR_CODE;
}
